import { useState, useEffect } from "react";
import { usePendingPaymentCheck } from "@/hooks/usePendingPaymentCheck";
import { PendingPaymentBanner } from "./PendingPaymentBanner";
import { PendingPaymentModal } from "./PendingPaymentModal";

export function PendingPaymentProvider() {
  const {
    pendingPayments,
    loading,
    hasUrgentPayment,
    urgentPayment,
    dismissBanner,
    isBannerDismissed,
  } = usePendingPaymentCheck();

  const [showUrgentModal, setShowUrgentModal] = useState(false);
  const [modalDismissed, setModalDismissed] = useState(false);

  // Show urgent modal when there's an urgent payment
  useEffect(() => {
    if (hasUrgentPayment && urgentPayment && !modalDismissed) {
      setShowUrgentModal(true);
    }
  }, [hasUrgentPayment, urgentPayment, modalDismissed]);

  // Don't render anything while loading or if no pending payments
  if (loading || pendingPayments.length === 0) {
    return null;
  }

  // Get the first pending payment for banner display
  const firstPayment = pendingPayments[0];

  return (
    <>
      {/* Show banner if not dismissed and no urgent modal */}
      {!isBannerDismissed && !showUrgentModal && (
        <PendingPaymentBanner
          count={pendingPayments.length}
          itemName={firstPayment.ticker?.name}
          amount={firstPayment.total_amount}
          onDismiss={dismissBanner}
        />
      )}

      {/* Show urgent modal for payments near timeout */}
      {urgentPayment && (
        <PendingPaymentModal
          open={showUrgentModal}
          onOpenChange={(open) => {
            setShowUrgentModal(open);
            if (!open) {
              setModalDismissed(true);
            }
          }}
          trade={urgentPayment}
        />
      )}
    </>
  );
}
